import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { PricingModal } from './PricingModal';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Reservas',
    href: '#reservar'
  }, {
    name: 'Precios',
    href: '#',
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      setIsPricingModalOpen(true);
    }
  }, {
    name: 'Academia',
    href: '#academia'
  }, {
    name: 'Color',
    href: '#color'
  }, {
    name: 'Sobre Mí',
    href: '#sobre-mi'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/80 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-171">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-172">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-2 group" data-id="element-173">
          <div className="w-2 h-2 rounded-full bg-neon-green shadow-[0_0_10px_rgba(74,222,128,0.8)] group-hover:bg-neon-violet transition-colors duration-300" data-id="element-174" />
          <span className="font-display text-2xl tracking-wider text-white" data-id="element-175">
            NINJA 2.0
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-176">
          <ul className="flex items-center gap-8" data-id="element-177">
            {navLinks.map(link => <li key={link.name} data-id="element-178">
                <a href={link.href} onClick={link.onClick} className="text-sm font-medium text-gray-300 hover:text-white transition-colors relative group" data-id="element-179">
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-neon-violet to-neon-green transition-all duration-300 group-hover:w-full" data-id="element-180" />
                </a>
              </li>)}
          </ul>
          <a href="#contacto" className="px-5 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 hover:border-neon-violet/50 transition-all text-sm font-medium backdrop-blur-sm" data-id="element-181">
            Agendar
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-182">
          {mobileMenuOpen ? <X size={24} data-id="element-183" /> : <Menu size={24} data-id="element-184" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 right-0 bg-[#0a0a0a]/95 backdrop-blur-xl border-b border-white/10 p-6 md:hidden flex flex-col gap-6" data-id="element-185">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
        if (link.onClick) {
          link.onClick(e);
        }
        setMobileMenuOpen(false);
      }} className="text-lg font-medium text-gray-300 hover:text-white" data-id="element-186">
              {link.name}
            </a>)}
          <a href="#contacto" onClick={() => setMobileMenuOpen(false)} className="w-full py-3 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-center font-semibold text-white mt-4" data-id="element-187">
            Agendar Turno
          </a>
        </motion.div>}

      <PricingModal isOpen={isPricingModalOpen} onClose={() => setIsPricingModalOpen(false)} data-id="element-188" />
    </nav>;
}